import React from "react";
import { useTranslation } from "react-i18next";

const FreeMedicinePrint = ({ data }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  return (
    <div
      style={{
        width: "210mm",
        height: "297mm", // A4 size
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        boxSizing: "border-box",
        direction: direction,
        position: "relative",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Header Section */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        {/* Left Section */}
        <div style={{ textAlign: "left" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "24px",
              fontWeight: "bold",
              color: "#000",
            }}
          >
            TURKISH CLINIC
          </h1>
          <p
            style={{
              margin: "5px 0",
              fontSize: "14px",
              fontWeight: "600",
              color: "#E91E63",
            }}
          >
            GAIN YOUR BEAUTY
          </p>
        </div>

        {/* Center Logo */}
        <div style={{ textAlign: "center" }}>
          <img
            src={`${process.env.REACT_APP_MEDIA_URL}/images/logo/logo.png`}
            alt="Clinic Logo"
            style={{ width: "160px", height: "auto", marginBottom: "5px" }}
          />
        </div>

        {/* Right Section */}
        <div style={{ textAlign: "right", direction: "rtl" }}>
          <h2
            style={{
              margin: 0,
              fontSize: "24px",
              fontWeight: "bold",
              color: "#E91E63",
            }}
          >
            ترکیش کلینیک
          </h2>
          <p style={{ margin: "5px 0", fontSize: "14px", color: "#333" }}>
            زیبایی خود را به دست آورید
          </p>
        </div>
      </header>

      {/* Order Details */}
      <div
        style={{
          fontSize: "14px",
          lineHeight: "1.6",
          color: "#333",
          marginBottom: "10px",
        }}
      >
        <strong>{t("pharmacy.order")}:</strong> #{data.id} - {data.date}
      </div>

      {/* Patient Info */}
      {data.reception && (
        <div
          style={{
            margin: "10px 0",
            padding: "8px",
            border: "1px dashed #ccc",
            borderRadius: "4px",
          }}
        >
          <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
            {t("reception.patientInfo")}:
          </div>
          <div>
            <strong>{t("reception.name")}:</strong>{" "}
            {data.patient_details.firstname}{" "}
            {data.patient_details.lastname || ""}
          </div>
          {data.patient_details.phone && (
            <div>
              <strong>{t("reception.phone")}:</strong>{" "}
              {data.patient_details.phone}
            </div>
          )}
          {data.patient_details.age && (
            <div>
              <strong>{t("reception.age")}:</strong> {data.patient_details.age}
            </div>
          )}
        </div>
      )}

      {/* Free Medicines Notice */}
      <div
        style={{
          margin: "10px 0",
          padding: "10px",
          backgroundColor: "#ffe6e6",
          border: "1px solid #e57373",
          borderRadius: "4px",
          color: "#e53935",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        <p style={{ margin: 0 }}>
          این دوا ها رایگان هستند و هیچ هزینه‌ای ندارند.
        </p>
      </div>

      {/* Medicine Items Table */}
      <table
        style={{
          width: "100%",
          fontSize: "12px",
          marginTop: "10px",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr>
            <th style={tableHeaderStyle}>{t("pharmacy.medicine")}</th>
            <th style={tableHeaderStyle}>{t("pharmacy.pricePerQuantity")}</th>
            <th style={tableHeaderStyle}>{t("pharmacy.quantity")}</th>
            <th style={tableHeaderStyle}>{t("pharmacy.subtotal")}</th>
          </tr>
        </thead>
        <tbody>
          {data?.items?.map((item, idx) => (
            <tr key={idx} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={tableCellStyle}>{item.stock_medicine_display}</td>
              <td style={{ ...tableCellStyle, textAlign: "center" }}>
                {item.sell_price_display}
              </td>
              <td style={{ ...tableCellStyle, textAlign: "center" }}>
                {item.quantity}
              </td>
              <td style={{ ...tableCellStyle, textAlign: "right" }}>
                {item.quantity * item.sell_price} ؋
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Total Amount */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid gray",
          paddingTop: "10px",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#333",
          marginTop: "10px",
        }}
      >
        <span>{t("print.totalAmount")}:</span>
        <span>{data.total_price} ؋</span>
      </div>

      {/* Footer Section */}
      <footer
        style={{
          marginTop: "20px",
          textAlign: "center",
          color: "#555",
          fontSize: "12px",
        }}
      >
        <p style={{ margin: "8px 0" }}>{t("print.thankYou")}</p>
        <p style={{ margin: "8px 0" }}>{t("print.getWellSoon")}</p>
        <p style={{ margin: "8px 0" }}>{t("print.poweredBy")}</p>
      </footer>
    </div>
  );
};

const tableHeaderStyle = {
  borderBottom: "1px solid #E91E63",
  padding: "8px",
  fontWeight: "bold",
  textAlign: "left",
  color: "#333",
};

const tableCellStyle = {
  padding: "8px",
  textAlign: "left",
  color: "#333",
};

export default FreeMedicinePrint;
